import { useSelector } from "react-redux";
import { RootState } from "../../../apis/store";
import { Col, Row, Tag } from "antd";
import PaginationComponent from "../../../Components/biblio/PaginationComponent";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import "moment/locale/ar";
import moment from "moment";
import ProfileTabState from "./ProfileTabState";

interface PropsTransaction {
  type: "loyalty" | "wallet";
}

function getHistoryRowsAndStatus(
  type: "loyalty" | "wallet",
  historyLoyalty: RootState["login"]["historyLoyalty"],
  historyWallet: RootState["login"]["historyWallet"]
): { rows: any[]; status: string } {
  const raw = type === "loyalty" ? historyLoyalty?.data : historyWallet?.data;
  if (Array.isArray(raw)) {
    return { rows: raw, status: "" };
  }
  if (raw && typeof raw === "object" && "data" in raw) {
    const o = raw as { data?: any[]; status?: string };
    return {
      rows: Array.isArray(o.data) ? o.data : [],
      status: o.status ?? "",
    };
  }
  return { rows: [], status: "" };
}

export const MyTransactionsHistory = ({ type }: PropsTransaction) => {
  const { t, i18n } = useTranslation();
  const itemPerPage = 8;
  const { historyLoyalty, historyWallet } = useSelector(
    (state: RootState) => state?.login
  );
  const [currentPage, setActive] = useState<number>(1);

  const { rows: rawRows, status: fetchStatus } = useMemo(
    () => getHistoryRowsAndStatus(type, historyLoyalty, historyWallet),
    [type, historyLoyalty, historyWallet]
  );

  const data = useMemo(() => {
    if (type === "loyalty") {
      return rawRows.filter((item: any) => item.points >= 1);
    }
    return rawRows;
  }, [type, rawRows]);

  const loading =
    fetchStatus === "idle" ||
    fetchStatus === "" ||
    (fetchStatus !== "succedded" && fetchStatus !== "rejected");

  const empty =
    (fetchStatus === "succedded" || fetchStatus === "rejected") &&
    data.length === 0;

  const emptyKey = type === "loyalty" ? "loyalty" : "wallet";

  return (
    <>
      <ProfileTabState
        loading={loading}
        empty={empty}
        emptyKey={emptyKey}
      >
        <div className="pb-50">
          {data
            .slice(itemPerPage * (currentPage - 1), itemPerPage * currentPage)
            .map((el: any) => (
              <div
                className="mt-20 pb-25 border-bottom"
                style={{ width: "90%" }}
                key={`${el.origin}-${el.date}-${el.points ?? el.amount}`}
              >
                <Row>
                  <Col xxl={6} xl={9} lg={24} md={24} sm={24} xs={24}>
                    <span className="text-md-bold ac--color-text-profile">
                      {t("profile.transaction.origin")} :{" "}
                      {t("profile.order.orderNumbes")}
                      {el.origin}
                    </span>
                  </Col>

                  <Col xxl={6} xl={5} lg={24} md={24} sm={24} xs={24}>
                    <span
                      className={`text-md-bold ac--color-text-profile ${
                        type !== "loyalty" ? "icon-saudi_riyal" : ""
                      }`}
                    >
                      {type === "loyalty" ? (
                        <>
                          {t("profile.points")}:{" "}
                          {Number.isInteger(el.points)
                            ? el.points
                            : Math.round(el.points)}
                        </>
                      ) : (
                        <>
                          {Number.isInteger(el.amount)
                            ? el.amount
                            : parseFloat(el.amount).toFixed(3)}{" "}
                        </>
                      )}
                    </span>
                  </Col>

                  <Col xxl={6} xl={6} lg={24} md={24} sm={24} xs={24}>
                    <span className="text-md-bold ac--color-text-profile">
                      {t("result.date")}:{" "}
                      {moment(el.date)
                        .locale(i18n.language === "ar" ? "ar" : "en")
                        .format("MMMM D, YYYY , h:mm a")}
                    </span>
                  </Col>
                  <Col xxl={6} xl={4} lg={24} md={24} sm={24} xs={24}>
                    <span className="text-md-bold ac--color-text-profile">
                      <Tag
                        className="ac--loyalty-history-tag"
                        color={
                          type === "loyalty"
                            ? el.type === "loss"
                              ? "blue"
                              : "green"
                            : el.type === "gain"
                            ? "green"
                            : "red"
                        }
                      >
                        {type === "loyalty"
                          ? el.type === "loss"
                            ? i18n.language === "ar"
                              ? "استبدال"
                              : "Redeem"
                            : i18n.language === "ar"
                            ? "اكتساب"
                            : "Reward"
                          : el.type === "gain"
                          ? i18n.language === "ar"
                            ? "إضافة رصيد"
                            : "Add Balance"
                          : i18n.language === "ar"
                          ? "خصم رصيد"
                          : "Deduct Balance"}
                      </Tag>
                    </span>
                  </Col>
                </Row>
              </div>
            ))}
        </div>
        {data.length > itemPerPage && (
          <PaginationComponent
            total={data.length}
            itemPerPage={itemPerPage}
            active={currentPage}
            setActive={(nb) => {
              setActive(nb);
            }}
          />
        )}
      </ProfileTabState>
    </>
  );
};
export default MyTransactionsHistory;
